import { render, staticRenderFns } from "./ReferralData.vue?vue&type=template&id=fee84610"
import script from "./ReferralData.vue?vue&type=script&lang=js"
export * from "./ReferralData.vue?vue&type=script&lang=js"
import style0 from "./ReferralData.vue?vue&type=style&index=0&id=fee84610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports